import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import * as d3 from 'd3';
import {Loader} from '../../../components/Loader/Loader';
import { AnalyticsSimpleTile } from '../AnalyticsSimpleTile/AnalyticsSimpleTile';
import { AnalyticsPopupTile } from '../AnalyticsPopupTile/AnalyticsPopupTile';
import handleViewport from 'react-in-viewport';
import FilterSwitcher from '../../../components/FilterSwitcher/FilterSwitcher';
import { AnalyticsSimpleTileCollapser } from '../AnalyticsSimpleTile/AnalyticsSimpleTileCollapser';
import cancelEvent from '../../../../services/mini/cancelEvent';
const $ = require('jquery');

const START_DIALOG = 'Start dialog';
const END_DIALOG = 'End dialog';
const UNRECOGNIZED = 'Unrecognized';
const SECTOR_OPACITY = .1;
class AnalyticPatternFlowTile extends React.Component {

    constructor(props) {
        super(props);
        this.patternFlowChart = React.createRef();
        this.state = this.prepareD3Data(props);
        this._isMounted = false;
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.report?.data?.patternFlowsDataUpdateTs !== nextProps.report?.data?.patternFlowsDataUpdateTs) {
            return true;
        }
        if (JSON.stringify(this.props.settings) !== JSON.stringify(nextProps.settings)) {
            return true;
        }
        return false;
    }

    componentDidMount() {
        this._isMounted = true;
        this.drawChart();
    }

    componentWillReceiveProps(nextProps) {
        this.setState(this.prepareD3Data(nextProps));
    }

    componentDidUpdate() {
        this.drawChart();
    }

    componentWillUnmount() {
        this._isMounted = true;
    }

    getPatternFlows(props) {
        return props.report?.data?.patternFlows;
    }

    prepareD3Data(props) {
        const patternFlows = this.getPatternFlows(props);

        const replaceDefaultNames = n => {
            if ("Unrecognized" === n) {
                return UNRECOGNIZED;
            } else if ("Start" === n) {
                return START_DIALOG;
            } else if ("End" === n) {
                return END_DIALOG;
            } else {
                return n;
            }
        };

        const convertPatternFlowsToD3 = (d) =>
            d.map(p => {
                return {
                    source: Object.assign(p.source, { pattern: replaceDefaultNames(p.source.pattern) }),
                    target: Object.assign(p.target, { pattern: replaceDefaultNames(p.target.pattern) }),
                    value: p.value
                };
            });

        const data = patternFlows ? convertPatternFlowsToD3(patternFlows) : [];
        const patterns = _.uniqBy(data.flatMap(d => [d.source, d.target]), p => p.pattern);
        const names = patterns.map(p => p.pattern);
        return { data, names };
    }

    resetSelection = () => {
        this.props.selectPattern();
    }

    sectorOnClick = (e, i) => {
        const { selectPattern } = this.props;
        if (selectPattern) {
            const pattern = this.state.names[i.index];
            selectPattern(null, null, pattern);
        }
    }

    drawChart = () => {
        if (!this._isMounted) return;

        const { data, names } = this.state;
        const { mode, selectedPattern } = this.props;
        const patternFlows = this.getPatternFlows(this.props);

        if (!patternFlows || patternFlows.length === 0) return;

        const index = new Map(names.map((name, i) => [name, i]));
        const matrix = Array.from(index, () => new Array(names.length).fill(0));
        for (const { source, target, value } of data) {
            matrix[index.get(source.pattern)][index.get(target.pattern)] += value;
        }

        var width = mode === 'big' ? 440 : 220;
        var height = width;
        var innerRadius = width * 0.5 - 25;
        var outerRadius = innerRadius + 12;

        var color = d3.scaleOrdinal(names, d3.schemeCategory10);

        const getColor = (ind) => {
            var name = names[ind];
            if (name === START_DIALOG) return '#0079e8';
            if (name === END_DIALOG) return '#ED4137';
            if (name === UNRECOGNIZED) return '#31383E';
            return color(names[ind]);
        };

        var ribbon = d3.ribbonArrow()
            .radius(innerRadius - 0.5)
            .padAngle(1 / innerRadius);

        var arc = d3.arc()
            .innerRadius(innerRadius)
            .outerRadius(outerRadius);

        var chord = d3.chordDirected()
            .padAngle(1 / innerRadius)
            .sortSubgroups(d3.descending)
            .sortChords(d3.descending);

        var count = 0;

        function uid(name) {
            return new Id("O-" + mode + (name == null ? "" : name + "-") + ++count);
        }

        function Id(id) {
            this.id = id;
            this.href = new URL(`#${id}`, window.location) + "";
        }

        Id.prototype.toString = function () {
            return "url(" + this.href + ")";
        };

        d3.select(this.patternFlowChart.current).selectAll("*").remove();

        var tooltip = d3.select(this.patternFlowChart.current)
            .append("div")
            .attr("class", "pattern-flow-tooltip")
            .style("opacity", 0);

        var svg = d3.select(this.patternFlowChart.current)
            .append("svg")
            .attr("viewBox", [-width / 2, -height / 2, width, height]);

        const chords = chord(matrix);

        const textId = uid("text");

        const name2IconMapping = {
            [START_DIALOG]: '\ue03b',
            [END_DIALOG]: '\ue03a',
            [UNRECOGNIZED]: '\ue00c'
        };

        svg.append("path")
            .attr("id", textId.id)
            .attr("fill", "none")
            .attr("d", d3.arc()({ outerRadius, startAngle: 0, endAngle: 2 * Math.PI }));

        svg.append("g")
            .attr("fill-opacity", 0.75)
            .attr("cursor", "pointer")
            .selectAll("g")
            .data(chords)
            .join("path")
            .attr("d", ribbon)
            .attr("fill", d => getColor(d.target.index))
            .style("mix-blend-mode", "multiply")
            .attr("class", "connector");

        svg.append("g")
            .attr("font-family", "sans-serif")
            .attr("font-size", 10)
            .selectAll("g")
            .data(chords.groups)
            .join("g")
            .call(g => g.append("path")
                .attr("d", arc)
                .attr("fill", d => getColor(d.index))
                .attr("cursor", "pointer")
                .attr("stroke", "#fff"))
            .attr("class", "sector")
            .call(g => g.append("text")
                .attr("dy", 10)
                .append("textPath")
                .attr("xlink:href", textId.href)
                .attr("fill", '#fff')
                .attr('font-family', 'alan-font')
                .attr('font-size', '8px')
                .attr('pointer-events', 'none')
                .attr("startOffset", d => d.startAngle * outerRadius + 2)
                .text((d) => {
                    var curName = names[d.index];
                    return name2IconMapping[curName];
                })
            )
            .call(g => g.append("text")
                .attr("dy", -3)
                .append("textPath")
                .attr("xlink:href", textId.href)
                .attr("fill", d => getColor(d.index))
                .attr("startOffset", d => d.startAngle * outerRadius)
                .text((d) => {
                    var sectorLength = innerRadius * (d.endAngle - d.startAngle);
                    if (sectorLength < 18) {
                        return '';
                    }
                    var charCount = (sectorLength) / 6;
                    var label = (names[d.index]);
                    if (label.length > charCount) {
                        return label.substr(0, charCount) + '...';
                    }
                    return label;
                })
            );

        function defaultHighlight() {
            if (selectedPattern != null) {
                let patternIndex = index.get(selectedPattern.pattern);
                highlightSelectedSector(patternIndex, SECTOR_OPACITY);
            }
        }
        defaultHighlight();

        svg.selectAll(".connector")
            .on("mouseover", connectorOnMouseOver(.1))
            .on("mouseout", onMouseOut(1));

        svg.selectAll(".sector")
            .on("mouseover", sectorOnMouseOver(SECTOR_OPACITY))
            .on("mouseout", onMouseOut(1))
            .on("click", this.sectorOnClick);

        function connectorOnMouseOver(opacity) {
            return function (e, i) {
                svg.selectAll(".connector")
                    .transition()
                    .style("opacity", opacity);

                d3.select(this).transition()
                    .style("opacity", 1);

                svg.selectAll(".sector")
                    .filter(function (d) {
                        return d.index !== i.source.index && d.index !== i.target.index;
                    })
                    .transition()
                    .style("opacity", opacity);

                svg.selectAll(".sector")
                    .filter(function (d) {
                        return d.index === i.source.index || d.index === i.target.index;
                    })
                    .transition()
                    .style("opacity", 1);

                showTooltip(e, getTooltip([i.source.index, i.target.index], i.source.value));
            };
        }
        function resetOpacity() {
            svg.selectAll(".connector")
                .transition()
                .style("opacity", 1);
            svg.selectAll(".sector")
                .transition()
                .style("opacity", 1);
        }

        function onMouseOut(opacity) {
            return function (g, i) {
                resetOpacity();
                defaultHighlight();
                hideTooltip();
            };
        }
        function showTooltip(e, htmlContent) {
            let x;
            if (window.innerWidth - e.clientX < 150) {
                x = e.layerX - 150;
            } else {
                x = e.layerX;
            }

            // tooltip.transition()
            //     .duration(300)
            //     .style("opacity", 1)
            //     .style("left", x + 'px')
            //     .style("top", e.layerY + 'px');

            tooltip.transition()
                .duration(300)
                .style("opacity", 1)
                .style("left", '10px')
                .style("top", '40px');

            tooltip.html(htmlContent);
        }
        function hideTooltip() {
            tooltip.transition()
                .duration(300)
                .style("opacity", 0);
        }

        function getTooltip(items, value) {
            var res = '<div><div style="float: left">';

            for (let i = 0; i < items.length; i++) {
                var index = items[i];
                res += '<div class="pattern-flow-tooltip__line">';
                res += '<div class="legend" style="background-color:' + getColor(index) + ';">' + (name2IconMapping[names[index]] || '') + '</div>';
                res += names[index];
                // if (value != null) {
                //     res += ' <b>' + value + '</b>';
                // }
                res += '</div>';
            }
            let transofrmStyle = items.length > 1 ? 'transform: translateY(50%);' : '';
            res += '</div><div style="float: right; padding-left: 10px; ' + transofrmStyle + '">' + (value != null ? value : '') + '</div>';
            res += '</div>';
            return res;
        }

        function highlightSelectedSector(index, opacity) {
            // resetOpacity();
            let sectorIndexes = [];
            let disabledConnectors = svg.selectAll(".connector")
                .filter(function (d) {
                    if (d.source.index === index || d.target.index === index) {
                        sectorIndexes.push(d.source.index);
                        sectorIndexes.push(d.target.index);
                    }
                    return d.source.index !== index && d.target.index !== index;
                });

            disabledConnectors
                .transition()
                .style("opacity", opacity);

            let enabledConnectors = svg.selectAll(".connector")
                .filter(function (d) {
                    if (d.source.index === index || d.target.index === index) {
                        sectorIndexes.push(d.source.index);
                        sectorIndexes.push(d.target.index);
                    }
                    return d.source.index === index || d.target.index === index;
                });

            enabledConnectors
                .transition()
                .style("opacity", 1);

            svg.selectAll(".sector")
                .filter(function (d) {
                    return sectorIndexes.indexOf(d.index) === -1;
                })
                .transition()
                .style("opacity", opacity);
        }

        function sectorOnMouseOver(opacity) {
            return function (e, i) {
                // var sectorIndexes = [];
                const value = i.index === 0 || i.index === index.size - 1 ? i.value : i.value / 2;
                showTooltip(e, getTooltip([i.index], value));

                highlightSelectedSector(i.index, opacity);

                // svg.selectAll(".connector")
                //     .filter(function (d) {
                //         if (d.source.index === i.index || d.target.index === i.index) {
                //             sectorIndexes.push(d.source.index);
                //             sectorIndexes.push(d.target.index);
                //         }
                //         return d.source.index !== i.index && d.target.index !== i.index;
                //     })
                //     .transition()
                //     .style("opacity", opacity);

                // svg.selectAll(".sector")
                //     .filter(function (d) {
                //         return sectorIndexes.indexOf(d.index) === -1;
                //     })
                //     .transition()
                //     .style("opacity", opacity);
            };
        }

        svg.node();
    }

    toggleShowEvents = (e) => {
        const {
            requestPaternFlowsWithEvents,
            report,
        } = this.props;
        requestPaternFlowsWithEvents(report, !report.onlyPatternOnPatternFlow);
        cancelEvent(e);
    }

    render() {
        const {
            environment,
            mode,
            report
        } = this.props;

        const patternFlows = this.getPatternFlows(this.props);
        return (
            <AnalyticsSimpleTile {...this.props}>
                <div className={`analytic-pattern-flows-tile ${environment} ${mode}`} onClick={this.resetSelection}>
                    <div className="analytic-pattern-flows-tile_header-wrapper">
                        <AnalyticsSimpleTileCollapser {...this.props}>
                            <div className="analytic-tile_header">
                                Pattern Flow
                            </div>
                        </AnalyticsSimpleTileCollapser>
                        <FilterSwitcher
                            labelIfTrue="Show events"
                            labelIfFalse="Show events"
                            offMode={true}
                            withBorder={true}
                            minWidth="initial"
                            maxWidth="initial"
                            onClick={this.toggleShowEvents}
                            value={!report.onlyPatternOnPatternFlow} />
                    </div>
                    {patternFlows ?
                        (patternFlows.length > 0 ? <div key={mode} className={`analytic-pattern-flows-tile_flow-area ${mode}`} ref={this.patternFlowChart} /> :
                            <div className="analytic-pattern-flows-tile_no-data">Not enough data to show this report.</div>) :
                        <Loader theme="dark" size="small" center={true} />}
                </div>
            </AnalyticsSimpleTile>
        );
    }
}

export default handleViewport(AnalyticsPopupTile(AnalyticPatternFlowTile));
